import { BUSINESS_TYPES } from "@/data/onboarding";
import { StepShell } from "../OnboardingPrimitives";

export default function StepBusiness({ state, update }) {
  return (
    <StepShell
      stepId="business"
      eyebrow="Step 02 · Your business"
      title={<>Tell us about <span className="italic text-aurora">your world.</span></>}
    >
      <div className="space-y-7">
        <div>
          <label htmlFor="ob-name" className="overline block mb-3">Business name</label>
          <input
            id="ob-name"
            data-testid="onboarding-business-name"
            value={state.business_name}
            onChange={(e) => update("business_name", e.target.value)}
            placeholder="e.g. Lumi Skin Studio"
            className="editorial-input"
            maxLength={120}
          />
        </div>
        <div>
          <span className="overline block mb-3">Type</span>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3">
            {BUSINESS_TYPES.map((t) => {
              const active = state.business_type === t;
              return (
                <button
                  key={t}
                  type="button"
                  data-testid={`onboarding-type-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  onClick={() => update("business_type", t)}
                  className={`px-3 py-3 rounded-sm text-sm transition border text-left ${
                    active
                      ? "border-transparent aurora-border bg-[#FAFAFA] text-neutral-900"
                      : "border-neutral-200 hover:border-[#D4AF37]/60 text-neutral-600"
                  }`}
                >
                  {t}
                </button>
              );
            })}
          </div>
        </div>
        <div>
          <label htmlFor="ob-audience" className="overline block mb-3">Your audience (one line)</label>
          <input
            id="ob-audience"
            data-testid="onboarding-audience"
            value={state.audience}
            onChange={(e) => update("audience", e.target.value)}
            placeholder="e.g. busy moms in Brookline who want results-based skincare"
            className="editorial-input"
            maxLength={240}
          />
          <p className="text-xs text-neutral-500 mt-2">Optional but helpful - the Studio uses this to tune every draft.</p>
        </div>
      </div>
    </StepShell>
  );
}
